import { CheckIcon, CloseIcon, DeleteIcon, EditIcon } from '@chakra-ui/icons'
import { Button, ButtonGroup, Editable, EditableInput, EditablePreview, Grid, IconButton, Link, Stack, useEditableControls } from '@chakra-ui/react'

import { DocumentIcon } from '@/components/Documents/DocumentIcon'

interface PpzAuthorizationFileProps {
  name: string
  downloadUrl?: string
  onUpdateName: (name: string) => void
  onDelete?: () => void
}

export const PpzAuthorizationFile = ({ name, downloadUrl, onUpdateName, onDelete }: PpzAuthorizationFileProps) => {

  return (<Grid gap='20px' p={3} px={4} background='neutral.50' borderRadius='md' boxShadow='xs'
    gridTemplateColumns={{
      base: '32px calc(100% - 52px)',
      md: '44px calc(100% - 64px)',
    }}
    alignItems='center'>
    <DocumentIcon documentType={name.split('.')?.at(1) ?? ''} flex={1} />
    <Stack gap={0} w='full' flexGrow={1}>
      <Editable defaultValue={name} fontWeight='medium' fontSize='lg' display='flex' gap={2} w='100%' onSubmit={onUpdateName} submitOnBlur={false}>
        <EditablePreview w='100%' maxW='calc(100% - 60px)' noOfLines={1} />
        <EditableInput />
        <EditableControls />
        {onDelete && <IconButton variant='ghost' py={2} px={2} size='lg' icon={<DeleteIcon />} onClick={onDelete} aria-label="Delete" />}
      </Editable>
      {downloadUrl && <Button as={Link} href={downloadUrl} target='_blank' variant="link" alignSelf='start'>stáhnout</Button>}
    </Stack>
  </Grid>)
}
function EditableControls() {
  const {
    isEditing,
    getSubmitButtonProps,
    getCancelButtonProps,
    getEditButtonProps,
  } = useEditableControls()

  return isEditing ? (
    <ButtonGroup justifyContent='center' size='md'>
      <IconButton variant='ghost' py={1} px={2} icon={<CheckIcon />} {...getSubmitButtonProps()} aria-label="Submit" />
      <IconButton variant='ghost' py={1} px={2} icon={<CloseIcon />} {...getCancelButtonProps()} aria-label="Close" />
    </ButtonGroup>
  ) : (
    <IconButton variant='ghost' py={1} px={2} size='lg' icon={<EditIcon />} {...getEditButtonProps()} aria-label="Edit" />
  )
}